import React from 'react'
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom'

import XdragonApi from './XdragonApi'

export default function MobileService() {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route
        exact
        path={`${path}`}
        render={() => <Redirect to={`${path}/xdragon`}></Redirect>}
      ></Route>
      <Route exact path={`${path}/xdragon`}>
        <XdragonApi></XdragonApi>
      </Route>
    </Switch>
  )
}
